import gql from 'not-graphql-tag';

export const getCommercialAccountsList = gql`
  query getCommercialAccountsList($params: AccountDetailListParams!) {
    getAccountDetailList(params: $params) {
      accounts {
        accountNumber
        accountType
        encryptedAccountNumber
        encryptedPersonId
        description
        mainCustomerName
        isActive
        premiseInfo {
          addressLine1
          addressLine2
          city
          state
          postal
          encryptedPremiseId
        }
      }
    }
  }
`;

export const getEnergyConsultationRequests = gql`
  query getEnergyConsultationRequests(
    $filterBy: EnergyConsultationRequestsFilter!
  ) {
    getEnergyConsultationRequests(filterBy: $filterBy) {
      requestDetails {
        businessName
        consultationType
        preferredContactMethod
        preferredDate
        preferredLanguage
        preferredTimeSlot
        businessNeedsCategory
        commercialRetailOfficeOptions
        largeCommercialIndustrialOptions
        otherBusinessNeed
        postalCode
      }
      status
      requestId
    }
  }
`;

export const submitEnergyConsultationMutation = gql`
  mutation submitEnergyConsultation($payload: EnergyConsultationRequest!) {
    submitEnergyConsultation(payload: $payload) {
      success
      requestId
    }
  }
`;

export const submitEnergyConsultationWatMutation = gql`
  mutation submitEnergyConsultationWat(
    $payload: WatEnergyConsultationRequest!
  ) {
    submitEnergyConsultationWat(payload: $payload) {
      success
      requestId
    }
  }
`;

export const cancelEnergyConsultationMutation = gql`
  mutation cancelEnergyConsultation(
    $payload: CancelEnergyConsultationRequest!
  ) {
    cancelEnergyConsultation(payload: $payload) {
      success
    }
  }
`;

export const rescheduleEnergyConsultationMutation = gql`
  mutation rescheduleEnergyConsultation(
    $payload: RescheduleEnergyConsultationRequest!
  ) {
    rescheduleEnergyConsultation(payload: $payload) {
      success
    }
  }
`;

export const getAvailableDatesForConsultation = gql`
  query GetEnergyConsultationMonthAvailability(
    $input: EnergyConsultationMonthAvailabilityInput!
  ) {
    getEnergyConsultationMonthAvailability(input: $input) {
      days {
        date
        hasAvailability
      }
    }
  }
`;

export const getAvailableTimeSlotsForConsultation = gql`
  query GetEnergyConsultationDayAvailability(
    $input: EnergyConsultationDayAvailabilityInput!
  ) {
    getEnergyConsultationDayAvailability(input: $input) {
      energyConsultationDate
      slots {
        slotTime
        available
      }
    }
  }
`;
